export enum GoustoHeaders {
  XGoustoTestEmailAddress = 'x-gousto-test-email-address',
  XGoustoFlexOrdersAllowed = 'x-gousto-flex-orders-allowed',
}
